<template>
  <a-row :gutter="[24, 24]">
    <a-col :xxl="5" :lg="6" :md="7">
      <typeTree title="分类名称" @handleClick="handleClick" />
    </a-col>
    <a-col :xxl="19" :lg="18" :md="17">
      <a-spin :spinning="loading">
        <a-card :bordered="false">
          <div class="table-page-search-wrapper">
            <a-form :form="form" layout="inline">
              <ResourceType
                ref="resourceType"
                :list="resourceTypeList"
                :treeDatas="treeDatas"
                @handleItem="handleItem"
              />
              <a-row :gutter="12">
                <a-col :span="8">
                  <a-form-item label="资源名称">
                    <a-input v-decorator="['fileName']"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="部门名称">
                    <a-input v-decorator="['deptName']"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="上传用户">
                    <a-input v-decorator="['uploadPerson']"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="上传时间">
                    <a-range-picker
                      v-decorator="['times']"
                      valueFormat="YYYY-MM-DD"
                      style="width:100%;min-width:100%"
                    ></a-range-picker>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" icon="search" @click="search"
                    >查询
                  </a-button>
                  <a-button
                    type="default"
                    icon="reload"
                    style="margin-left:8px"
                    @click="handleReset"
                    >重置
                  </a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <div class="table-operator">
            <a-button type="primary" icon="upload" @click="upload"
              >上传</a-button
            >
            <a-button type="danger" icon="delete" @click="delSelect"
              >删除
            </a-button>
            <a-button type="edit" icon="edit" @click="edit">编辑</a-button>
          </div>
          <uploadModal
            ref="upload"
            @refreshWord="editSubmitSuccess"
            :params="params"
          />
          <typeSection
            :items="items"
            @spin="e => (loading = e)"
            @idsChange="idsChange"
          />
          <template>
            <a-pagination
              v-model="current"
              :page-size-options="pageSizeOptions"
              :total="total"
              show-size-changer
              :page-size="pageSize"
              @showSizeChange="onShowSizeChange"
              @change="onChange"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                <span v-if="props.value === '50'">全部</span>
              </template>
            </a-pagination>
          </template>
        </a-card>
      </a-spin>
    </a-col>
  </a-row>
</template>
<script>
import typeTree from "@/components/TypeTree/index";
import typeSection from "@/components/TypeSection/index";
import uploadModal from "./modules/upload";
import ResourceType from "./modules/resourceType";
//api
import { findPage, del, inquire, findOne } from "@/api/base/resource/manager";

export default {
  components: {
    typeTree,
    typeSection,
    uploadModal,
    ResourceType
  },
  data() {
    return {
      model: {},
      //选择的id串
      ids: "",
      //form
      form: this.$form.createForm(this),
      items: [],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      current: 1,
      pageSize: 10,
      total: 50,
      loading: false,
      resourceTypeList: [],
      resourType: "",
      treeDatas: {},
      //type类型
      params: {
        type: "",
        id: "",
        resourName: "",
        visible: false,
        createdUserName: "",
        fileId: "",
        resour: [
          {
            uid: "",
            name: "",
            url: "",
            status: "done"
          }
        ]
      },
      idss: []
    };
  },

  mounted() {
    let params = {
      page: this.current,
      rows: this.pageSize
    };
    this.initData(params);
  },

  methods: {
    handleItem(rows) {
      console.log("rows", rows);
      this.items = rows;
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
      let params = {
        page: current,
        rows: this.pageSize
      };
      this.initData(params);
    },

    search() {
      // console.log(this.form.getFieldsValue());
      let data = this.form.getFieldsValue();
      if (data.times) {
        data.times = data.times.toString();
      }

      let params = {
        // keyValue: data.keyValue,
        // times: data.times && data.times.toString(),
        page: 1,
        rows: this.pageSize,
        resourType: this.resourType
      };
      params = Object.assign(params, data);
      this.initData(params);
    },

    upload() {
      this.params = {};
      this.params.type = "上传资源";
      (this.params.visible = true), this.$refs.upload.show();
    },

    //编辑
    edit() {
      if (!this.ids || this.idss.length > 1) {
        this.$notification.warning({
          message: "请选择一个栏目进行编辑"
        });
        return;
      }
      this.params.id = this.ids;
      this.params.type = "编辑";
      this.params.visible = false;
      findOne({ id: this.ids }).then(res => {
        if (res.resultCode != 0) {
          this.$refs.upload.show(this.params);
          this.params.resourName = res.result.resourName;
          this.params.name = res.result.name;
          this.params.createdUserName = res.result.createdUserName;
          this.params.resourType = res.result.resourType;
          this.params.resourUrl = res.result.resourUrl;
          this.params.resourId = res.result.resourId;
        } else {
          this.$notification.error({
            message: res.message
          });
        }
      });
    },

    onChange(current) {
      console.log(current);
      this.current = current;
      let params = {
        page: current,
        rows: this.pageSize
      };
      this.initData(params);
    },

    handleClick(id) {
      console.log("id", id);
      this.resourType = id;
      // 初始化查询参数
      this.current = 1;
      let params = {
        page: this.current,
        rows: this.pageSize
      };
      this.treeDatas = params;
      // 如果存在类型id
      if (id) params.resourType = id;
      this.initData({ ...params });
      this.classification(id);

      this.resourceTypeList = [];
      this.$refs.resourceType.resetChildren();
    },

    hanleRadioChange(e) {
      console.log("e", e);
    },

    idsChange(ids) {
      this.idss = [];
      this.idss.push(ids);
      this.ids = ids;
      this.params.fileId = ids;
    },

    initData(params) {
      findPage(params).then(res => {
        this.items = res.result.rows;
        this.total = res.result.records;
        this.current = res.result.page;
        // console.log("最新页码：", this.current);
      });
    },
    // // 分类展示
    classification(id) {
      inquire({ partentid: id }).then(res => {
        this.resourceTypeList = res.result[0].jtypes;
        this.$refs.resourceType.resetChildren();
      });
    },
    delSelect() {
      console.log("删除的ids:", this.ids);

      if (!this.ids) {
        this.$notification.warning({
          message: "请选择删除栏目"
        });
        return;
      }

      let pars = { ids: this.ids };
      del({ ...pars }).then(res => {
        if (res.resultCode === 1) {
          this.$notification.success({
            message: res.message
          });
          this.current = 1;
          let params = {
            page: 1,
            rows: this.pageSize
          };
          this.initData({ ...params });

          this.ids = "";
          // eslint-disable-next-line no-empty
        } else if (res.resultCode === 3) {
          const _this = this;
          _this.$confirm({
            title: "提示",
            content: "存在任务资源，是否确定删除?",
            onOk() {
              del({ ...pars, whether: true }).then(res => {
                if (res.resultCode === 1) {
                  _this.$notification.success({
                    message: res.message
                  });
                  _this.current = 1;
                  let params = {
                    page: 1,
                    rows: _this.pageSize
                  };
                  _this.initData({ ...params });

                  _this.ids = "";
                }
              });
            }
          });
        } else {
          this.$notification.error({
            message: res.message
          });
        }
      });
    },

    editSubmitSuccess() {
      console.log("新增数据");
      this.current = 1;
      let params = {
        page: 1,
        rows: this.pageSize
      };
      this.initData({ ...params });
    },

    // 查询条件重置
    handleReset() {
      console.log(" === handleReset click === ");

      this.form.resetFields();
    }
  }
};
</script>
<style>
.home {
  cursor: pointer;
  margin-left: 15px;
}
.home:hover {
  color: cornflowerblue;
}
.class {
  width: 100%;
  height: 64px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
